import React, { useState } from "react";
import img1 from "../../Assets/Project/img1.jpeg";
import img2 from "../../Assets/Project/img2.jpeg";
import img3 from "../../Assets/Project/img3.jpeg";
import img4 from "../../Assets/Project/img4.jpeg";
import img5 from "../../Assets/Project/img5.jpeg";
// import img6 from "../../Assets/Project/img6.png";
// import img7 from "../../Assets/Project/img7.png";
// import img8 from "../../Assets/Project/img8.png";
// import img9 from "../../Assets/Project/img9.png";

const projectsData = [
  {
    name: "All Projects",
    images: [img1, img2, img3, img4, img5],
  },
];

const RailwaySection = () => {
  const [isActiveNav, setIsActiveNav] = useState("All Projects");

  const activeProject = projectsData.find(
    (project) => project.name.toLowerCase() === isActiveNav.toLowerCase()
  );

  return (
    <div className="w-full h-full p-[20px_32px]  md:p-[20px_64px] mb-4 md:mb-8">
      <h2
        data-aos="fade-up"
        style={{ fontFamily: "Nunito, sans-serif" }}
        className="text-3xl md:text-5xl font-semibold tracking-wide text-center mb-4 mt-4 md:mb-8 md:mt-8"
      >
        Water Testing Room
      </h2>
      {/* <nav className="flex overflow-x-auto whitespace-nowrap space-x-10 border-b-2 border-gray-300 mb-4 md:mb-8">
        {projects.map((project, index) => (
          <div
            style={{ fontFamily: "Poppins, sans-serif" }}
            onClick={() => setIsActiveNav(project)}
            key={index}
            className={`px-3 text-md md:text-lg font-medium tracking-wider py-3 cursor-pointer ${
              isActiveNav.toLowerCase() === project.toLowerCase()
                ? "border-b-2 border-[#0218DC] text-[#0218DC]"
                : ""
            }`}
          >
            {project}
          </div>
        ))}
      </nav> */}

      <div className="grid grid-cols-10 gap-4">
        {activeProject?.images.map((image, index) => (
          <div
            key={index}
            data-aos={
              index % 2 === 0
                ? "fade-right"
                : index % 3 === 0
                ? "flip-left"
                : "fade-left"
            }
            className={`${
              index === 0 || index === 4 || index === 6
                ? "col-span-4 md:col-span-2"
                : index === 1 || index === 3 || index === 7
                ? "col-span-6 md:col-span-4"
                : "col-span-10 md:col-span-4"
            } h-[200px] md:h-[250px]`}
          >
            <img
              src={image}
              alt={`Project Image ${index + 1}`}
              className="w-full h-full rounded-md object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RailwaySection;
